import { render, staticRenderFns } from "./ChannelControl.vue?vue&type=template&id=18ba9d03&"
import script from "./ChannelControl.vue?vue&type=script&lang=js&"
export * from "./ChannelControl.vue?vue&type=script&lang=js&"
import style0 from "./ChannelControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports